import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';
import AttendanceFilter from '../../leave/LeaveBalance/LeaveTransSearchFilter';
import toastr from 'toastr';
import axios from 'axios';
import csvConvert from '../../../classes/csvConvert';

let csv = new csvConvert();
class DownloadHome extends React.Component {

    constructor() {
        super();
        this.state={csv: null,loading: false};
        this.onSubmitTrans = this.onSubmitTrans.bind(this);
    }
    downloadCsv(tableData)
    {
      let blob = new Blob([tableData], {type: "text/csv;charset=utf-8;"});
      blob = window.webkitURL.createObjectURL(blob);

      if (!tableData.match(/^data:text\/csv/i)) {
        tableData = 'data:text/csv;charset=utf-8,' + tableData;
      }

      let getCsv = new Promise((resolve, reject)=> {
        this.setState({csv: blob});
        resolve(true);
      });
      getCsv.then((response)=> {
        this.download.click();
      })

    }
    onSubmitTrans(request)
    {
      if(request.startDate==null || request.endDate == null) {
        toastr.error("Select Dates");
        return;
      }

      let requestObject ={};
      requestObject.startDate = moment(request.startDate).format('YYYY-MM-DD');
      requestObject.endDate = moment(request.endDate).format('YYYY-MM-DD');
      requestObject.empId = request.selected;
      requestObject.type= request.option1?"all":(request.option2?"exit":null);
      this.setState({loading: true})
      axios.get(process.env.REQ_URL + "/attendance/getUnregularisedAttendance?q="+JSON.stringify(requestObject),{withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=>{
        let result = response.data.data;
        if(result!=null) {
          if(response.data.data.length==0)
          {this.setState({loading: false})
            return;}
          let finalResult = csv.convertArrayOfAnyObjectsToCSV({data: response.data.data});

          this.downloadCsv(finalResult);
          this.setState({loading: false})
        }



      }).catch((error)=>{
        console.log(error);
        toastr.error("Error Occurred");
      })

    }
    componentDidMount()
    {
      this.props.changeBanner("Downloads");
    }

    render() {
        return (
          <div>
            <div className="col-md-12" style={{borderTop: 'solid 1px',borderBottom: 'solid 1px'}}>
              <h2><u>Attendance Unregularised</u></h2>
              <AttendanceFilter   activeEmployees={this.props.activeEmployees}
                                  loading={this.state.loading}
                                        option1="all" option2="exit" onSubmit={this.onSubmitTrans}/>
              <a href={this.state.csv} download={"AttendanceUnregularised.csv"} ref={(input) => {
                this.download = input;
              }}/>

            </div>
           </div>
              );
    }

}

DownloadHome.propTypes = {};

function mapStateToProps(state, ownState) {
    return {
      activeEmployees: state.employees
    };

}

export default connect(mapStateToProps)(DownloadHome);




/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/download/DownloadHome.js
 **/